import React from "react";
import CpntInscriptionStatus from "../../components/CpntInscriptionStatus";

const PageInscriptionValidationEmail: React.FC = () => {
  return (
    <CpntInscriptionStatus
      title="VALIDATION DE VOTRE E-MAIL"
      messages={[
        "Un e-mail vous a été adressé à l'e-mail renseignée. Merci de sélectionner le lien contenu dans celui-ci pour poursuivre votre inscription."
      ]}
      imgAlt="Validation email"
    />
  );
};

export default PageInscriptionValidationEmail;
